import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/services/auth.service';
import { SendMoneyService } from '../send-money.service';
import { MessageService } from 'primeng/api';
import { CommonService } from 'src/app/services/common.service';
import { Capacitor } from '@capacitor/core';

import { THIS_EXPR } from '@angular/compiler/src/output/output_ast';

declare var webengage
@Component({
  selector: 'app-step3',
  templateUrl: './step3.component.html',
  styleUrls: ['./step3.component.scss']
})
export class Step3Component implements OnInit {
  conversionRate: any = 0
  transactionFees: any = 0
  gatewayFee
  totalAmountDeducted = 0
  convertedAmount = 0
  paymentTypes = []
  allfundingSources = []
  resultFundingSources = []
  selectedCaPaymentMethod = null
  gatewayFees = 0
  source_amount
  maxLimitReached = false
  coupon_code
  discounted_amount
  coupon_id
  is_applied_coupon = false
  funding_source = ""
  error_monthly_limit = ""
  maxUserLimit = false
  old_transaction_fees
  old_totalAmount_deducted
  celoData = {
    response: {},
    paymentSelectedoption: {
      payment_gateways_id: null,
      payment_id: null
    },
    celoWalletNumber: ''
  };


  constructor(public sendMoneyService: SendMoneyService, public messageService: MessageService, public auth: AuthService, public router: Router, public common: CommonService) { }

  max_amount
  ngOnInit(): void {
    webengage.track("enter_transfer_purpose", {
      "Reason": this.sendMoneyService.purpose?.remittance_purpose,
      "Payment Description": this.sendMoneyService.purpose?.note || this.sendMoneyService.purpose?.reason_code
    })
    this.auth.get_monthly_limit(this.auth.user.id);
    if (this.sendMoneyService.isAcknowlodgingRequest) {
      this.source_amount = this.sendMoneyService.requestedSendingAmount
      this.onAmountChange({ target: { value: this.source_amount } })
    }
    this.selectedCaPaymentMethod = this.sendMoneyService.selectedCAPaymentMethod
    if (!(this.sendMoneyService.purpose && this.sendMoneyService.receiver)) {
      this.router.navigateByUrl("/send-money/step1")
    } else {

      this.sendMoneyService.isMarkTransaction = true
      if (this.auth.user.country_id == 233) {
        this.common.showLoader()
        this.sendMoneyService.getFundingSource().subscribe((res: any) => {
          //console.log(res)
          this.allfundingSources = res.results
          if (this.allfundingSources.length == 0) {
            this.router.navigateByUrl("manage-payment-methods")
            this.messageService.add({ severity: 'error', summary: 'Payment Methods Not Found', detail: "Plese add Payment Method First" });
          }
          if (this.isBankAvailable()) {
            this.paymentTypes.push("BANK")
          }
          if (this.isCardAvailable()) {
            this.paymentTypes.push("CARD")
          }
          this.common.stopLoader()
        })
      }
    }

    this.sendMoneyService.getConversionRate(this.auth.user?.currency, this.sendMoneyService.receiver?.payee_country || this.sendMoneyService.receiver?.country_id, 1).subscribe((res: any) => {
      if (res) {
        this.conversionRate = res.data.currency_conversion_rate
      }
    },
      err => {
        this.messageService.add({ severity: 'error', summary: 'Exchange Rate is not available for this transaction', detail: "" });
        this.router.navigateByUrl("/send-money/step1")
      })

    this.sendMoneyService.getTransactionFees(this.auth.user?.currency, this.sendMoneyService.receiver?.currency, 1).subscribe(res => {
      this.transactionFees = +res['fee']
      this.gatewayFee = res['gateway_fee']
    })
    if (this.sendMoneyService.transactionDetails?.selectedCaPaymentMethod) {
      this.source_amount = this.sendMoneyService.transactionDetails.selectedCaPaymentMethod
    }

    if (this.sendMoneyService.transactionDetails?.sending_amt) {
      this.source_amount = this.sendMoneyService.transactionDetails.sending_amt
      this.onAmountChange({ target: { value: this.source_amount } })
    }



  }
  onFormSubmit(transactionForm) {
    transactionForm.value.fee_amount = this.transactionFees
    transactionForm.value.fee_amount = this.transactionFees
    transactionForm.value.amount = this.totalAmountDeducted.toFixed(2)
    transactionForm.value.exchange_rate = this.conversionRate

    transactionForm.value.gateway_fee = this.gatewayFee
    this.sendMoneyService.transactionDetails = transactionForm.value

    transactionForm.value.discounted_amount = this.discounted_amount
    transactionForm.value.coupon_code = this.coupon_code
    transactionForm.value.coupon_id = this.coupon_id
    //console.log(this.sendMoneyService.transactionDetails)
    this.sendMoneyService.fundingSource = this.resultFundingSources.find(element => {
      return element.id == transactionForm.value.funding_source_id
    })
    this.router.navigateByUrl("/send-money/step4")
  }

  onAmountChange(event) {
    this.source_amount = event.target.value
    this.discounted_amount = this.source_amount
    if (this.is_applied_coupon) {
      this.resetCoupon()
    }
    if ((+this.source_amount + +this.transactionFees + (+this.selectedCaPaymentMethod?.gateway_fee || 0)) > +this.common.max_left_daily && +this.common.max_left_daily <= +this.common.max_left_monthly) {
      if (this.auth.user.country_id == 39) {
        this.error_monthly_limit = `Your daily limit is $${this.common.max_limit_daily}. Contact support@n2xpress.com to increase your limit.`
      }
      else if (this.auth.user.country_id == 233) {
        this.error_monthly_limit = `You can transfer $${this.common.max_left_daily} including fees, to increase your limit please request for "<a class="text-primary cursor-pointer" href="/upgrade-tier">Limit increase</a>".`
      }

      // this.source_amount = null
      // this.discounted_amount = null
      this.convertedAmount = null
      // this.totalAmountDeducted = 0
      this.maxUserLimit = true
    }
    else if ((+this.source_amount + +this.transactionFees) > +this.common.max_left_monthly) {
      this.error_monthly_limit = `Your monthly limit is $${this.common.max_limit_monthly}. Contact support@n2xpress.com to increase your limit.`
      // this.source_amount = null
      // this.discounted_amount = null
      this.convertedAmount = null
      // this.totalAmountDeducted = 0
      this.maxUserLimit = true

    }
    else {
      this.maxUserLimit = false
      this.error_monthly_limit = ''
      if (!this.sendMoneyService.selectedCAPaymentMethod) {
        this.error_monthly_limit = ''
        this.sendMoneyService.getConversionRate(this.auth.user.currency, this.sendMoneyService.receiver.payee_country || this.sendMoneyService.receiver?.country_id, this.source_amount, this.celoData.paymentSelectedoption.payment_id).subscribe((res: any) => {
          //console.log(res)
          if (res.return) {
            this.conversionRate = res.data.currency_conversion_rate
            this.convertedAmount = res.data.converted_amount
            if (this.setMaxLimit(this.convertedAmount, this.sendMoneyService.receiver.currency)) {
              this.maxLimitReached = false
              this.sendMoneyService.getTransactionFees(this.auth.user.currency, this.sendMoneyService.receiver.currency, this.source_amount).subscribe(res => {
                this.transactionFees = +res['fee']
                this.gatewayFee = res['gateway_fee']
                if (this.auth.user.country_id == 233)
                  this.totalAmountDeducted = +this.discounted_amount + +this.transactionFees + +this.gatewayFee

                else
                  this.totalAmountDeducted = +this.discounted_amount + +this.transactionFees
                this.totalAmountDeducted = +this.totalAmountDeducted.toFixed(2)
              })
            }
            else {
              this.transactionFees = 0
              this.totalAmountDeducted = 0
              // this.source_amount = 0
              this.maxLimitReached = true
            }

          }
          else {

          }
          this.common.stopLoader()
        },
          err => {
            //console.log(err)
            this.messageService.add({ severity: 'error', summary: 'Exchange Rate is not available for this transaction', detail: "" });
            this.router.navigateByUrl("/send-money/step1")
          })
      }
      else {
        this.error_monthly_limit = ''
        if (+this.source_amount > +this.sendMoneyService.selectedCAPaymentMethod.max_limit) {
          this.messageService.add({ 'severity': 'error', 'summary': 'Max limit reached', 'detail': `Cannot send more than ${this.sendMoneyService.selectedCAPaymentMethod.max_limit} for selected gateway type.` })
          this.source_amount = null
          this.discounted_amount = null
          this.convertedAmount = null
          this.totalAmountDeducted = 0
        }
        else {
          if (this.source_amount) {
            this.common.showLoader()
            this.sendMoneyService.getConversionRate(this.auth.user.currency, this.sendMoneyService.receiver.payee_country || this.sendMoneyService.receiver?.country_id, this.source_amount).subscribe((res: any) => {
              if (res.return) {
                this.conversionRate = res.data.currency_conversion_rate
                // this.convertedAmount = this.conversionRate * this.source_amount
                // this.convertedAmount=+this.convertedAmount.toFixed(2)
                this.convertedAmount = res.data.converted_amount
                if (this.setMaxLimit(this.convertedAmount, this.sendMoneyService.receiver.currency)) {
                  this.maxLimitReached = false
                  this.sendMoneyService.getTransactionFees(this.auth.user.currency, this.sendMoneyService.receiver.currency, this.source_amount).subscribe(res => {
                    this.transactionFees = +res['fee']
                    !this.selectedCaPaymentMethod.gateway_fee_type ?
                      this.totalAmountDeducted = +this.discounted_amount + +this.transactionFees + +this.selectedCaPaymentMethod.gateway_fee :
                      this.totalAmountDeducted = (+this.discounted_amount + +this.transactionFees) * (1 + (this.selectedCaPaymentMethod.gateway_fee) / 100)
                    this.totalAmountDeducted = +this.totalAmountDeducted.toFixed(2)
                    this.totalAmountDeducted = +this.totalAmountDeducted.toFixed(2)

                    this.common.stopLoader()
                  }, err => {
                    //console.log(err)
                    // this.messageService.add({severity:'error', summary:'Something went wrong', detail:""});
                    this.common.stopLoader()

                  })
                }
                else {
                  this.transactionFees = 0
                  this.totalAmountDeducted = 0
                  // this.source_amount = 0
                  this.maxLimitReached = true
                  this.common.stopLoader()
                }

              }
              else {
                this.common.stopLoader()
                this.messageService.add({ severity: 'error', summary: 'Something went wrong', detail: "" });

              }
              // this.common.stopLoader()
            },
              err => {
                //console.log(err)
                this.messageService.add({ severity: 'error', summary: 'Exchange Rate is not available for this transaction', detail: "" });
                this.router.navigateByUrl("/send-money/step1")
                this.common.stopLoader()

              })
          }

        }

      }
    }



  }


  isBankAvailable() {
    return this.allfundingSources.find(element => {
      return element.funding_source_type == "BANK"
    })
  }

  isCardAvailable() {
    return this.allfundingSources.find(element => {
      return element.funding_source_type == "CARD"
    })
  }

  onPaymentTypeChange(type) {
    this.resultFundingSources = this.allfundingSources.filter(element => {
      return element.funding_source_type == type
    })
    // console.log(this.sendMoneyService.caPaymentMethods)

  }

  goBack() {
    this.router.navigateByUrl("/send-money/step2")
    this.sendMoneyService.isMarkTransaction = false
  }



  onSelectCAPaymentMethod(item) {
    console.log('click onSelectCAPaymentMethod', item);
      this.celoData.paymentSelectedoption = item;

    if (item.payment_id == 6) {
      this.sendMoneyService.getConversionRate(this.auth.user.currency, this.sendMoneyService.receiver.payee_country || this.sendMoneyService.receiver?.country_id, this.source_amount, item.payment_id).subscribe((res: any) => {
        console.log(res);
        this.celoData.response = res.data;
        // this.celoData.paymentSelectedoption = item;
        console.log("this.celoData.paymentSelectedoption");
        console.log(this.celoData.paymentSelectedoption);
      }, (err) => {
        console.log(err);
      });
    }
    
    // else{
    //   this.celoData.paymentSelectedoption.payment_id=item.payment_id
    //   this.celoData.paymentSelectedoption.payment_gateways_id=item.payment_id
    // }


    if (this.auth.user.country_id == 39) {
      if (this.is_applied_coupon) {
        this.resetCoupon()
        // this.sendMoneyService.getTransactionFees(this.auth.user.currency, this.sendMoneyService.receiver.currency, this.source_amount).subscribe( res => {
        //   this.transactionFees = +res['fee']
        //   !item.gateway_fee_type ? 
        //   this.totalAmountDeducted = +this.discounted_amount + +this.transactionFees + +item.gateway_fee :
        //   this.totalAmountDeducted = ( +this.discounted_amount + +this.transactionFees ) * (1 + (item.gateway_fee)/100) 
        //   this.totalAmountDeducted=+this.totalAmountDeducted.toFixed(2)
        //   this.totalAmountDeducted = +this.totalAmountDeducted.toFixed(2)

        //   this.common.stopLoader()
        // }, err =>{
        //   //console.log(err)
        //   // this.messageService.add({severity:'error', summary:'Something went wrong', detail:""});
        //   this.common.stopLoader()

        // })
      }

      this.selectedCaPaymentMethod = item
      if (+this.source_amount > +item.max_limit) {
        this.messageService.add({ 'severity': 'error', 'summary': 'Max limit reached', 'detail': `Cannot send more than ${item.max_limit} for selected gateway type.` })
        this.source_amount = null
        this.convertedAmount = null
        this.totalAmountDeducted = 0


      }
      this.sendMoneyService.selectedCAPaymentMethod = item
      if (this.source_amount) {
        !this.selectedCaPaymentMethod.gateway_fee_type ?
          this.totalAmountDeducted = +this.source_amount + +this.transactionFees + +this.selectedCaPaymentMethod.gateway_fee :
          this.totalAmountDeducted = (+this.source_amount + +this.transactionFees) * (1 + (this.selectedCaPaymentMethod.gateway_fee) / 100)
        this.totalAmountDeducted = +this.totalAmountDeducted.toFixed(2)
        if (+this.totalAmountDeducted > +this.common.max_left_daily && +this.common.max_left_daily <= +this.common.max_left_monthly) {
          if (this.auth.user.country_id == 39) {
            this.error_monthly_limit = `Your daily limit is $${this.common.max_limit_daily}. Contact support@n2xpress.com to increase your limit.`
          }
          else if (this.auth.user.country_id == 233) {
            this.error_monthly_limit = `You can transfer $${this.common.max_left_daily} including fees, to increase your limit please request for "<a class="text-primary cursor-pointer" href="/upgrade-tier">Limit increase</a>".`
          }
          this.maxUserLimit = true
        }
        else if (+this.totalAmountDeducted > +this.common.max_left_monthly) {
          this.error_monthly_limit = `Your monthly limit is $${this.common.max_limit_monthly}. Contact support@n2xpress.com to increase your limit.`
          this.maxUserLimit = true

        }
        else {
          this.maxUserLimit = false
          this.error_monthly_limit = ''

        }
      }
      else {
        this.totalAmountDeducted = 0
      }
    }
  }

  onCaFormSubmit(caTRansactionForm) {
    console.log(caTRansactionForm);
    caTRansactionForm.value.fee_amount = this.transactionFees
    caTRansactionForm.value.amount = this.totalAmountDeducted
    caTRansactionForm.value.exchange_rate = this.conversionRate
    caTRansactionForm.value.discounted_amount = this.discounted_amount
    caTRansactionForm.value.coupon_code = this.coupon_code
    caTRansactionForm.value.coupon_id = this.coupon_id

    this.sendMoneyService.transactionDetails = caTRansactionForm.value;
    this.sendMoneyService.transactionDetails.celoData = this.celoData;

    console.log("caTRansactionForm.value ", caTRansactionForm.value);
    console.log("this.celoData.celoWalletNumber ", this.celoData.celoWalletNumber);
    this.router.navigateByUrl("/send-money/step4")
    //this.router.navigate(["send-money/step4"], { queryParams: { mydata: JSON.stringify(this.sendMoneyService) } });

  }

  setMaxLimit(amount, currency) {
    //India -> 15,00,000 INR
    //Ghana -> 10,000 GHS
    //Benin/Senegal -> 10,00,000 XOF
    //Philippines -> 10,00,00,000 PHP
    //Kenya -> 10,00,00,000 KES
    //South Africa -> 10,00,00,000 ZAR
    //Nigeria -> 10,00,000 NGN
    let maxLimit = {
      'inr': 1500000,
      'ghs': 10000,
      'xof': 1000000,
      'php': 100000000,
      'kes': 100000000,
      'zar': 100000000,
      'ngn': 1000000
    }
    return maxLimit[currency] < amount ? false : true

  }

  setMinLimit() {
    return +this.source_amount < 10 ? true : false
  }


  changeHeight() {
    //console.log(this.funding_source)
    if (this.auth.user.country_id == 233) {
      (document.getElementsByClassName("div-block-15")[0].classList.contains('more-height'))
        ? document.getElementsByClassName("div-block-15")[0].classList.remove('more-height')
        : document.getElementsByClassName("div-block-15")[0].classList.add('more-height')
    }

  }

  addPromo(e) {
    e.preventDefault()
    if (this.coupon_code)
      this.sendMoneyService.checkPromo(this.coupon_code, this.discounted_amount, this.sendMoneyService.receiver.payee_country || this.sendMoneyService.receiver.country_id, this.selectedCaPaymentMethod?.id || this.sendMoneyService.caPaymentMethods[0].id).subscribe((res: any) => {
        // console.log(res)
        // amount: "10" ---> amount or percentage
        // applied_for: "web" ----> platform web || app || both CHECK
        // code: "test1" ---> coupon code CHECK
        // country_id: 0 ---> 0->both || 39 -> canada|| 233 -> usa CHECK
        // coupon_count: null ---> number of times coupon can be used by all users combined
        // coupon_for: null ---> not of current use
        // discount_applied_for: "0" 0---> sending value || 1 ---> transaction fee CHECK
        // expires_at: "2021-02-26" ---> expiry date of coupon CHECK
        // id: 1 ---> coupon id not of our use currently {in second api along with user id (new api)}
        // max_amount: null ---> max amount on which coupon is applicable ---> CHECK
        // min_amount: null ---> min amount on which coupon is applicable ---> CHECK
        // type: "1" ---> 0 : percentage || 1 : numeric
        // user_id: 0 ---> all users || particular user id CHECK

        if (res.success) {
          this.old_transaction_fees = this.transactionFees
          this.old_totalAmount_deducted = this.totalAmountDeducted
          this.totalAmountDeducted = res.data.total_amount
          this.discounted_amount = res.data.discounted_amount
          this.transactionFees = res.data.new_trans_fee
          this.coupon_id = res.data.coupon_id
          this.is_applied_coupon = true
          this.messageService.add({
            severity: 'success',
            summary: `${res.message}`
          })
        }
        else {
          this.messageService.add({
            severity: 'error',
            summary: `${res.message}`
          })
          this.coupon_code = ''
        }

      }, err => {
        this.messageService.add({
          severity: 'error',
          // detail:'Coupon not applicable',
          summary: `${err.error.message}`
        })
        this.coupon_code = ''
      })
    else {
      this.messageService.add({
        severity: 'error',
        // detail:'Coupon not applicable',
        summary: 'Please enter a coupon code'
      })
    }
  }


  resetCoupon() {
    this.messageService.add({ 'severity': 'info', 'summary': 'Your coupon has been reset' })
    this.coupon_code = ''
    this.coupon_id = ''
    this.is_applied_coupon = false
    this.discounted_amount = +this.source_amount
    this.transactionFees = this.old_transaction_fees
    this.totalAmountDeducted = this.old_totalAmount_deducted
  }

  temp() {
    console.log("Jey John");

  }

  omit_special_char(event)
  {   
    var k;  
    k = event.charCode;  //k = event.keyCode;  (Both can be used)
    return((k > 64 && k < 91) || (k > 96 && k < 123) || k == 8 || k == 32 || (k >= 48 && k <= 57)); 
  }
}
